export default "__VITE_ASSET__EikghsDd__"